/**
 * @description 跳转到指定小程序页面
 * @param path 小程序页面地址
 */
export const navigateTo = (path:string) => {
  if (typeof path !== 'string') {
    return false
  } else {
    window.wx.miniProgram.navigateTo({'url': path})
  }
}
